<template>
  <div>
    <span class="ml-3 mt-3" v-if="!statusHistory.length <= 0">
      <i class="fa fa-clock mr-2 color-orange font-18" />
      <span class="title">
        Historial de Estatus
      </span>
    </span>

    <br />
    <div v-if="statusHistory.length <= 0" class="mb-4">
      <CustomResultNotFound class="mb-4 " text="Sin Historial para mostrar." />
    </div>
    <div v-else>
      <time-line class="mt-4 col-11 mx-auto px-0">
        <time-line-item
          v-for="(status, index) in statusHistory"
          :key="index"
          class="custom-time-line rounded"
        >
          <div class="row">
            <div class="col-12 col-md-2 flex-column d-flex">
              <span class="d-flex align-items-baseline">
                <div
                  class="status-indicator mb-1"
                  :class="`bg--${getColorStatus(status.status.id)}`"
                >
                  <span class="text-center mt-1">{{ status.status.name }}</span>
                </div>
              </span>
            </div>
            <div class="col-12 col-md-4 mb-2 flex-column d-flex">
              <label class="mb-0 color-gray-6 font-14"
                >{{ getLabelStatus(status.status.id) }} Por:</label
              >
              <span>{{ status.name }}</span>
            </div>
            <div
              class="col-12 col-md-6 mb-2 flex-column d-flex"
              v-if="showReason(status.status.id)"
            >
              <label class="mb-0 color-gray-6 font-14">Razón de Estatus:</label>
              <span>{{ status.reason | empty }}</span>
            </div>
          </div>
          <div class="row" v-if="showInfoCard(status.reason, status.comment)">
            <div class="col-md-2"></div>
            <div class="col-md-10">
              <div id="comment-info" class="mt-3">
                <div class="info-panel bg-white rounded">
                  <div class="info-panel-container">
                    <div class="info-panel-item row">
                      <div class="col-12 col-md-9">
                        <label>{{ status.comment | empty }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <template #icon>
            <em
              :class="
                `fas fa-${getIconStatus(
                  status.status.id
                )} text-white fa-lg font-16`
              "
              class="radius-icon"
            />
          </template>
          <template #date>
            <div class="date-container">
              <div class="color-black font-16 font-weight-bold fulldate">
                {{ formatDate(status.dateOfAction) }}
              </div>
              <div class="color-black font-14 font-weight-normal hour">
                {{ status.dateOfAction | hour }}
              </div>
            </div>
          </template>
        </time-line-item>
      </time-line>
    </div>
  </div>
</template>

<script>
import ActionButton from "ActionButton";
import { TimeLine, TimeLineItem } from "@quisit/mipe-timeline";
import months from "@/utils/constants/months";
import submittedDocumentDeterminationStatus from "@/utils/constants/student/submittedDocumentDeterminationStatus";
import { Colors } from "@/components/common";
import IconView from "icon-view";
import rlvServices from "@/services/api/rlvEvidence";
import CustomResultNotFound from "custom-result-not-found";
export default {
  name: "RlvHistory",
  components: {
    ActionButton,
    TimeLine,
    TimeLineItem,
    IconView,
    CustomResultNotFound
  },
  data() {
    return {
      statusHistory: []
    };
  },
  props: {
    documentInfo: {
      type: Object,
      default: null
    }
  },
  computed: {
    showReason() {
      return statusId =>
        statusId == submittedDocumentDeterminationStatus.Denegado;
    },
    documentDetails() {
      if (!this.documentInfo) return;
      return [
        [
          {
            label: "Número Estipulación:",
            data: this.documentInfo.courtStipulations,
            icon: "fas fa-clipboard-list-check"
          },
          {
            label: "Escuela:",
            data: `${this.documentInfo.sieSchoolId} - ${this.documentInfo.schoolName}`,
            icon: "fas fa-clipboard-list-check"
          },
          {
            label: "Tipo de documento:",
            data: this.documentInfo.submittedDocumentTypeName,
            icon: "fas fa-clipboard-list-check"
          }
        ]
      ];
    }
  },
  methods: {
    showInfoCard(reason, comments) {
      return (
        (reason != null && reason != "") || (comments != null && comments != "")
      );
    },
    formatDate(value) {
      const date = new Date(value).toLocaleDateString("es-ES").split("/");
      return `${date[0]}/${months[date[1] - 1]}/${date[2]}`;
    },
    getColorStatus(status) {
      switch (status) {
        case submittedDocumentDeterminationStatus.NoSometido:
          return Colors.LIGHTBLUE;
        case submittedDocumentDeterminationStatus.Sometido:
          return Colors.YELLOW;
        case submittedDocumentDeterminationStatus.Denegado:
          return Colors.BROWN;
        case submittedDocumentDeterminationStatus.Aprobado:
        default:
          return Colors.GREEN;
      }
    },
    getLabelStatus(status) {
      switch (status) {
        case submittedDocumentDeterminationStatus.NoSometido:
          return "Creado";
        case submittedDocumentDeterminationStatus.Sometido:
          return "Sometido";
        case submittedDocumentDeterminationStatus.Denegado:
        case submittedDocumentDeterminationStatus.Aprobado:
          return "Determinado";
      }
    },
    getIconStatus(status) {
      switch (status) {
        case submittedDocumentDeterminationStatus.NoSometido:
          return "file-invoice";
        case submittedDocumentDeterminationStatus.Sometido:
          return "flag";
        case submittedDocumentDeterminationStatus.Denegado:
          return "times-circle";
        case submittedDocumentDeterminationStatus.Aprobado:
        default:
          return "check-circle";
      }
    }
  },
  async mounted() {
    rlvServices.getHistory(this.documentInfo.submittedDocumentId).then(res => {
      this.statusHistory = res.data;
    });
  }
};
</script>

<style lang="scss" scoped>
.status-indicator {
  width: 156px;
  height: 33px;
  border-radius: 17px;
  display: table;
}
.text-center {
  display: block;
  text-align: center;
}
.text-small {
  font-size: 0.875rem;
}
.info-panel {
  padding: 15px 10px 1px 20px;
  border-bottom: none;
  border-radius: 0px 0px 5px 5px;
  opacity: 1;
}
.radius-icon {
  padding: 8px;
  padding-top: 12px;
  width: 36px;
  height: 36px;
  text-align: center;
  background-color: #b5c3bc;
  border-radius: 50%;
}
.info-panel-container {
  display: flex;
  flex-flow: row wrap;
  padding: 0px 10px 1px 23px;
  .info-panel-item {
    flex: 1 0 25%;
    margin-bottom: 5px;
    float: left;
    box-sizing: border-box;
    padding-right: 10px;
    span {
      display: block;
      text-align: left;

      letter-spacing: 0px;
    }
    label {
      margin-top: 10px;
      text-align: left;
      font-size: 1rem;
      letter-spacing: 0px;

      line-height: 1.6em;
    }
  }
}
</style>
